import React, { useEffect, useState } from "react";
import "./login.scss";
import VellmartLogo from "../../images/logos/vellmartLogo.svg";
import TextInput from "../../components/textInput/TextInput";
import CheckboxWithLable from "../../components/checkboxes/checkboxWithLable/CheckboxWithLable";
import { useNavigate } from "react-router-dom";
import LoginButton from "../../components/buttons/loginButton/LoginButton";
import { useGetCookieQuery, useGetPageQuery, usePingQuery, useSingInMutation } from "../../redux/services/velmartAPI";
import { useDispatch } from "react-redux";
import { setStatus } from "../../redux/slices/statusSlice";

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [singIn, { error }] = useSingInMutation();
    const { data: ping, refetch: refetchPing } = usePingQuery("");
    const { data: cookie } = useGetCookieQuery("");

    useEffect(() => {
        if (error?.status === 418) {
            alert("Логін або пароль введені невірно");
        }
    }, [error]);

    const sendFormHandler = async () => {
        const formData = {
            email: email,
            password: password,
        };

        try {
            await singIn({ body: formData, url: "sign-in" }).unwrap();
        } catch (e) {
            console.log(e);
        }
        await refetchPing();
    };

    useEffect(() => {
        if (ping?.user) {
            localStorage.setItem("isLoged", JSON.stringify(true));
            dispatch(setStatus(true));
            navigate("/dashboard");
        }
    }, [ping]);

    return (
        <div className="wrapper">
            <div className="login__content">
                <img src={VellmartLogo} alt="Vellmart" className="login__content-logo" />
                <div className="login__content-title">Авторизація</div>
                <div className="login__content-email-input">
                    <TextInput placeholder={"E-mail"} type={"email"} setInputValue={setEmail} inputValue={email} />
                </div>

                <div className="login__content-password-input">
                    <TextInput
                        placeholder={"Пароль"}
                        type={"password"}
                        setInputValue={setPassword}
                        inputValue={password}
                    />
                </div>
                <div className="login__content-checkbox-input">
                    <CheckboxWithLable lableText={"Запам'ятати мене"} />
                </div>
                <div className="login__content-button">
                    <LoginButton text={"Авторизуватися"} onClick={() => sendFormHandler()} />
                </div>
            </div>
        </div>
    );
};

export default Login;
